<template>
  <v-container fluid>
    <v-row>
      <v-text-field v-model="password" label="Password" counter :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword">
      </v-text-field>
    </v-row>
    <v-row>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>Background</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-slider v-model="bg_roundRadius" min="0" max="20" step="0.01" @end="send('bg_roundRadius')" label="Round radius" thumb-label="always"></v-slider>
            <v-slider v-model="bg_depth" min="10" max="200" step="0.1" @end="send('bg_depth')" label="Depth" thumb-label="always"></v-slider>
            <v-slider v-model="bg_segments" min="3" max="32" step="0.01" @end="send('bg_segments')" label="Segments" thumb-label="always"></v-slider>
            <v-slider v-model="bg_frontMargin" min="0" max="100" step="0.1" @end="send('bg_frontMargin')" label="Front Margin" thumb-label="always"></v-slider>
            <v-color-picker @input="send('bg_color')" mode="rgba" v-model="bg_color" label="Color" hide-mode-switch />
            <v-row><v-switch inset v-model="bg_visible" label="Visible" @change="send('bg_visible')"></v-switch></v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Lights</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row><v-switch inset v-model="lights_showHelpers" label="Helpers" @change="send('lights_showHelpers')"></v-switch></v-row>
            <v-slider v-model="lights_ambientLightIntensity" min="0" max="2" step="0.01" @end="send('lights_ambientLightIntensity')" label="Ambient" thumb-label="always"></v-slider>
            <v-color-picker @input="send('lights_ambientLightColor')" mode="rgba" v-model="lights_ambientLightColor" label="Ambient" hide-mode-switch />

            <v-slider v-model="lights_centerLightIntensity" min="0" max="2" step="0.01" @end="send('lights_centerLightIntensity')" label="Center" thumb-label="always"></v-slider>
            <v-color-picker @input="send('lights_centerLightColor')" mode="rgba" v-model="lights_centerLightColor" label="Center" hide-mode-switch />

            <v-slider v-model="lights_directionalLightIntensity" min="0" max="3" step="0.01" @end="send('lights_directionalLightIntensity')" label="Directional" thumb-label="always"></v-slider>

            <v-slider v-model="lights_topSpotlightIntensity" min="0" max="2" step="0.01" @end="send('lights_topSpotlightIntensity')" label="Top Spot" thumb-label="always"></v-slider>
            <v-color-picker @input="send('lights_topSpotlightColor')" mode="rgba" v-model="lights_topSpotlightColor" label="Top Spot" hide-mode-switch />

            <v-slider v-model="lights_bottomSpotlightIntensity" min="0" max="2" step="0.01" @end="send('lights_bottomSpotlightIntensity')" label="Bottom Spot" thumb-label="always"></v-slider>
            <v-color-picker @input="send('lights_bottomSpotlightColor')" mode="rgba" v-model="lights_bottomSpotlightColor" label="Bottom Spot" hide-mode-switch />

            <v-slider v-model="lights_timeOffset" min="-360" max="720" step="1" @end="send('lights_timeOffset')" label="Time Offset" thumb-label="always"></v-slider>

          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Vehicles</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row><v-switch inset v-model="vehicles_enabled" label="Enabled" @change="send('vehicles_enabled')"></v-switch></v-row>
            <v-row><v-switch inset v-model="vehicles_showPaths" label="Show Paths" @change="send('vehicles_showPaths')"></v-switch></v-row>
            <v-row><v-switch inset v-model="vehicles_ignoreTrams" label="Ignore Trams" @change="send('vehicles_ignoreTrams')"></v-switch></v-row>
            <v-col><v-btn @click="send('vehicles_add')">Add Vehicle</v-btn></v-col>
            <v-col><v-btn @click="send('vehicles_addTram1')">Add Tram 1</v-btn>
            <v-btn @click="send('vehicles_addTram2')">Add Tram 2</v-btn></v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Post Processing</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row><v-switch inset v-model="post_enabled" label="Enabled" @change="send('post_enabled')"></v-switch></v-row>
            <v-slider v-model="post_lut_strength" min="0" max="1" step="0.01" @end="send('post_lut_strength')" label="LUT Strength" thumb-label="always"></v-slider>
            <v-slider v-model="post_lut_mix" min="0" max="1" step="0.01" @end="send('post_lut_mix')" label="LUT Mix" thumb-label="always"></v-slider>
            <v-slider v-model="post_aberration_amount" min="0" max="0.01" step="0.001" @end="send('post_aberration_amount')" label="Aberration" thumb-label="always"></v-slider>
            <v-slider v-model="post_bloom_threshold" min="0.8" max="1" step="0.01" @end="send('post_bloom_threshold')" label="Bloom Threshold" thumb-label="always"></v-slider>
            <v-slider v-model="post_bloom_strength" min="0" max="5" step="0.01" @end="send('post_bloom_strength')" label="Bloom Strength" thumb-label="always"></v-slider>
            <v-slider v-model="post_bloom_radius" min="0" max="5" step="0.01" @end="send('post_bloom_radius')" label="Bloom Radius" thumb-label="always"></v-slider>
            <v-slider v-model="post_bokeh_focus" min="80" max="130" step="0.1" @end="send('post_bokeh_focus')" label="Bokeh Focus" thumb-label="always"></v-slider>
            <v-slider v-model="post_bokeh_aperture" min="0" max="100" step="0.01" @end="send('post_bokeh_aperture')" label="Bokeh Aperture" thumb-label="always"></v-slider>
            <v-slider v-model="post_bokeh_maxblur" min="0" max="0.1" step="0.001" @end="send('post_bokeh_maxblur')" label="Bokeh Max Blur" thumb-label="always"></v-slider>
          </v-expansion-panel-content>
        </v-expansion-panel>
      <v-expansion-panel>
          <v-expansion-panel-header>Misc</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-slider v-model="sculptingMode" min="0" max="1" step="1" @end="send('sculptingMode')" label="Sculpting Mode" thumb-label="always"></v-slider>
            <v-slider v-model="fade" min="0" max="1" step="0.01" @end="send('fade')" label="Fade" thumb-label="always"></v-slider>
            <v-row><v-switch inset v-model="pause" label="Pause" @change="send('pause')"></v-switch></v-row>
            <v-switch inset v-model="wireframe" label="Wireframe" @change="send('wireframe')"></v-switch>

            <v-switch inset v-model="markers" label="Markers" @change="send('markers')"></v-switch>
            <v-switch inset v-model="marker_white" label="White Marker" @change="send('marker_white')"></v-switch>
            <v-switch inset v-model="popularity_interval" label="Popularity Interval" @change="send('popularity_interval')"></v-switch>
            <v-switch inset v-model="times_active" label="Cron" @change="send('times_active')"></v-switch>
            <v-row>
              <v-col><v-btn @click="send('regenerate')">REGENERATE</v-btn></v-col>
              <v-col><v-btn @click="send('toggleFps')">TOGGLE FPS</v-btn></v-col>
              <v-col><v-btn @click="send('screenshot')">SCREENSHOT</v-btn></v-col>
              <v-col><v-btn @click="send('export')">EXPORT</v-btn></v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row>
      <v-col><v-btn @click="send('save')">SAVE</v-btn></v-col>
      <v-col><v-btn @click="send('load')">LOAD</v-btn></v-col>
    </v-row>
  </v-container>
</template>

<script>
import io from 'socket.io-client'
import md5 from 'md5'
export default {
  data: () => ({
    host: 'http://188.65.46.203:4043', // http://192.168.1.226:4043
    showPassword: false,
    password: '',
    bg_roundRadius: 1.4314720812182742,
    bg_depth: 29.771573604060915,
    bg_segments: 10,
    bg_frontMargin: 0,
    bg_color: '#ffffff',
    bg_visible: true,
    lights_showHelpers: false,
    lights_ambientLightIntensity: 0.5763113367174281,
    lights_ambientLightColor: '#ffffff',
    lights_centerLightIntensity: 0.5329949238578681,
    lights_centerLightColor: '#fff9d0',
    lights_directionalLightIntensity: 0.5720812182741116,
    lights_topSpotlightIntensity: 0.6196277495769882,
    lights_topSpotlightColor: '#b4d7ff',
    lights_bottomSpotlightIntensity: 0.9661590524534687,
    lights_bottomSpotlightColor: '#ffab4e',
    lights_timeOffset: 232,
    vehicles_showPaths: false,
    vehicles_enabled: true,
    post_enabled: true,
    post_lut_strength: 0.66,
    post_lut_mix: 0.76,
    post_aberration_amount: 0.002,
    post_bloom_threshold: 0.93,
    post_bloom_strength: 0.35786802030456855,
    post_bloom_radius: 0.6827411167512689,
    post_bokeh_focus: 106.30000000000001,
    post_bokeh_aperture: 46.14,
    post_bokeh_maxblur: 0.03,
    wireframe: false,
    sculptingMode: 0,
    pause: false,
    markers: false,
    marker_white: false,
    popularity_interval: false,
    times_active: true
  }),
  created: function () {
    this.$socket = io(this.host, { secure: true, rejectUnauthorized: false })
    this.$socket.on('update', (data) => { this.update(data) })
  },
  methods: {
    send: function (field, value) {
      if (this.password.length) {
        console.log('sending: ', md5(this.password), field, this[field])
        this.$socket.emit('settings', { password: md5(this.password), field, value: this[field] })
      }
    },
    update: function (data) {
      Object.keys(data).forEach((o) => {
        if (this[o] !== undefined) {
          this[o] = data[o]
        }
      })
    }
  }
}
</script>
